export function isUnpaidOrderError(message: string) {
    const normalized = message.toLowerCase()
    return normalized.includes("неоплачен") && normalized.includes("заказ")
}
